import React from "react";
import HeroSlider from "../components/HeroSlider";
import Footer from "../components/Footer";
import CorporateSidebar from "../components/Corporate/CorporateSidebar";

const CorporateVision = () => {
  return (
    <>
      <HeroSlider />
      <section className="max-w-7xl mx-auto px-4 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
        {/* Sol Menü */}
        <aside className="md:col-span-1">
          <CorporateSidebar />
        </aside>

        {/* Ana içerik */}
        <main className="md:col-span-3 space-y-6">
          <h1 className="text-3xl font-bold text-green-700 mb-4 border-b pb-2">
            Vizyonumuz
          </h1>
          <p className="text-gray-700 leading-relaxed">
            Halı yıkama sektöründe dijitalleşmiş, kurumsallaşmış ve müşteri memnuniyetini merkeze alan öncü firma olmak.
            Temizlik teknolojilerindeki yenilikleri yakından takip ederek, sürekli gelişen ve büyüyen bir yapıyla İstanbul'un her noktasında kaliteli hizmet vermeyi hedefliyoruz.
          </p>
        </main>
      </section>
      <Footer />
    </>
  );
};

export default CorporateVision;
